import React from "react";
import clsx from "clsx";
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import InputIcon from "@material-ui/icons/Input";
import Logo from "./Logo";
import MenuNavBar from "./MenuNavBar";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles({
  root: {},
  toolbar: {
    height: 91,
    marginLeft: "6%",
  },
  small: {
    flexGrow: 1,
  },
  big: {
    width: "100%",
  },
  nav: {
    width: "100%",
    paddingRight: "8%",
    minWidth: "80%",
    // marginRight: '-15%',
    // marginTop: '0%'
  },
  icons: {
    // marginTop: '0.9%'
  },
});

const PrivateTopBar = ({ className, onMobileNavOpen, onLogout, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      color="secondary"
      {...rest}
      position="static"
    >
      <Toolbar className={classes.toolbar}>
        <Hidden only={["md", "sm", "xs"]}>
          <Box className={classes.big}>
            <RouterLink to="/">
              <Logo width="100%" />
            </RouterLink>
          </Box>

          <Box className={classes.nav}>
            <MenuNavBar />
          </Box>
          <IconButton
            className={classes.icons}
            color="inherit"
            onClick={onLogout}
          >
            <InputIcon />
          </IconButton>
        </Hidden>

        <Hidden lgUp>
          <Box className={classes.small}>
            <RouterLink to="/">
              <Logo width="21%" />
            </RouterLink>
          </Box>

          <IconButton color="inherit" onClick={onLogout}>
            <InputIcon />
          </IconButton>

          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

export default PrivateTopBar;
